import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/EmsContactForm';
// FOR ONE GRAPHQL QUERY
export const SUBMIT_FORM = defineAsyncActionTypes(`${prefix}/SUBMIT_FORM`);
